export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-900 text-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <span className="text-lg font-heading font-bold tracking-wide">海角网</span>
            <p className="mt-3 text-xs text-foreground-300 leading-relaxed">
              海角网是一个汇聚千万原创内容的综合社区平台，涵盖海角视频、海角社区、海角论坛，每日更新海量优质资源，海角网址入口稳定可靠。
            </p>
          </div>

          <div>
            <h4 className="text-xs font-medium text-background-50/80 uppercase tracking-wider mb-3">
              快速导航
            </h4>
            <div className="space-y-2">
              {[
                { label: '热门榜单', href: '#ranking' },
                { label: '焦点专题', href: '#carousel' },
                { label: '话题广场', href: '#topics' },
                { label: '海角视频', href: '#media' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="block text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-medium text-background-50/80 uppercase tracking-wider mb-3">
              服务支持
            </h4>
            <div className="space-y-2">
              {[
                { label: '关于海角网', href: '#about' },
                { label: '常见问题', href: '#faq' },
                { label: '联系我们', href: '#contact' },
                { label: '最新动态', href: '#updates' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="block text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-medium text-background-50/80 uppercase tracking-wider mb-3">
              合作伙伴
            </h4>
            <p className="text-xs text-foreground-400">
              合作伙伴信息持续更新中
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2026 海角网 - 海角网千万原创与海角网官网入口。保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#hero"
              onClick={(e) => handleNavClick(e, '#hero')}
              className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
            >
              首页
            </a>
            <a
              href="#about"
              onClick={(e) => handleNavClick(e, '#about')}
              className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
            >
              关于
            </a>
            <a
              href="#contact"
              onClick={(e) => handleNavClick(e, '#contact')}
              className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
            >
              联系
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}